import { useWatch } from 'react-hook-form';
import { FormField } from 'v5/design-system/Form';
import { Input, TextArea } from 'v5/design-system/Input';
import { useFieldContext } from '../FieldContext';
import { EmptyField } from './EmptyField';
import { FieldControlBase } from './FieldControlBase';
import type { FieldSpecOf } from 'v5/core/entity-schema/entitySchema.types';
import type { FieldFrameSpec, FieldPartProps } from './fieldComponent.types';

/** Input, or auto-growing textarea when `multiline`. */
export function TextField({
  spec,
  path,
  hideLabel
}: FieldPartProps<
  FieldFrameSpec & Pick<FieldSpecOf<'text'>, 'multiline' | 'placeholder'>
>) {
  const ctx = useFieldContext();
  const readOnly = ctx.mode === 'display';
  const text: string = useWatch({ name: path }) ?? '';

  if (readOnly && text === '') {
    return <EmptyField spec={spec} path={path} hideLabel={hideLabel} />;
  }

  return (
    <FormField
      name={path}
      render={({ field }) => {
        const Component = spec.multiline ? TextArea : Input;
        return (
          <FieldControlBase spec={spec} hideLabel={hideLabel}>
            <Component
              readOnly={readOnly}
              variant={ctx.variant}
              size={ctx.size}
              placeholder={spec.placeholder ?? undefined}
              {...field}
              value={field.value ?? ''}
            />
          </FieldControlBase>
        );
      }}
    />
  );
}
